<template>
    <div v-if="pessoa" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Pessoa Física</h4>
        <router-link to="/cadastros/pessoas-fisicas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="Dados Pessoais">
          <p><strong>Nome:</strong> {{ pessoa.nome }}</p>
          <p><strong>CPF:</strong> {{ formatarCPF(pessoa.cpf) }}</p>
          <p><strong>RG:</strong> {{ formatarCPF(pessoa.rg) }}</p>
          <p><strong>Data de Nascimento:</strong> {{ utils.formatarData(pessoa.data_nascimento) }}</p>
          <p><strong>Sexo:</strong> {{ getSexoDescricao(pessoa.sexo) }}</p>
          <p><strong>Nacionalidade:</strong> {{ pessoa.nacionalidade || 'Não informado' }}</p>
          <p><strong>Naturalidade:</strong> {{ pessoa.naturalidade || 'Não informado' }}</p>
          <p><strong>Sócio:</strong> {{ pessoa.socio ? 'Sim' : 'Não' }}</p>
        </FormSection>
  
        <FormSection title="Contato">
          <p><strong>Telefone:</strong> {{ formatarContato(pessoa.telefone_ddi, pessoa.telefone) }}</p>
          <p><strong>Celular:</strong> {{ formatarContato(pessoa.celular_ddi, pessoa.celular) }}</p>
          <p><strong>E-mail:</strong> {{ pessoa.email || 'Não informado' }}</p>
        </FormSection>
  
        <FormSection title="Endereço">
          <p><strong>CEP:</strong> {{ pessoa.cep || 'Não informado' }}</p>
          <p><strong>Endereço:</strong> {{ pessoa.endereco || 'Não informado' }}</p>
          <p><strong>Número:</strong> {{ pessoa.numero || 'Não informado' }}</p>
          <p><strong>Bairro:</strong> {{ pessoa.bairro || 'Não informado' }}</p>
          <p><strong>Complemento:</strong> {{ pessoa.complemento || 'Não informado' }}</p>
          <p><strong>Estado:</strong> {{ pessoa.estado_nome || 'Não informado' }}</p>
          <p><strong>Município:</strong> {{ pessoa.municipio_nome || 'Não informado' }}</p>
        </FormSection>
  
        <FormSection title="Observações">
          <p>{{ pessoa.observacoes || 'Não informado' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
      
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  import globalUtils from "@/utils/globalUtils.js";
  
  export default {
    components: { FormSection },
    data() {
      return {
        pessoa: null,
      };
    },

    computed: {
      utils() {
        return globalUtils;
      }
    },

    methods: {
        async carregarDetalhes() {
        try {
            const response = await axios.get(
            `/cadastros/pessoas-fisicas/${this.$route.params.id}`
            );
            this.pessoa = response.data;

            // Após carregar os detalhes, carregue os nomes do estado e município
            await this.carregarEstadoNome();
            await this.carregarMunicipioNome();
        } catch (error) {
            console.error("Erro ao carregar os detalhes da pessoa fisica:", error);
        }
        },

        async carregarEstadoNome() {
        try {
            const response = await axios.get(`/localidades/estados`);
            this.estados = response.data;

            // Procura o estado pelo código e atribui o nome
            const estado = this.estados.find((e) => e.id === this.pessoa.estado_cod);
            this.pessoa.estado_nome = estado ? estado.nome : "Não informado";
        } catch (error) {
            console.error("Erro ao carregar estados:", error);
        }
        },

        async carregarMunicipioNome() {
        try {
            if (!this.pessoa.estado_cod) {
            this.pessoa.municipio_nome = "Não informado";
            return;
            }

            const response = await axios.get(
            `/localidades/municipios/${this.pessoa.estado_cod}`
            );
            this.municipios = response.data;

            // Procura o município pelo código e atribui o nome
            const municipio = this.municipios.find(
            (m) => m.id === this.pessoa.municipio_cod
            );
            this.pessoa.municipio_nome = municipio ? municipio.nome : "Não informado";
        } catch (error) {
            console.error("Erro ao carregar municípios:", error);
        }
        },

        formatarContato(ddi, numero) {
            if (!numero) return 'Não informado';
            return `${ddi || '+55'} ${numero}`;
        },

        // Método para converter o valor de sexo
        getSexoDescricao(sexo) {
            if (sexo === 'M') return 'Masculino';
            if (sexo === 'F') return 'Feminino';
            return 'Não informado';
        },
        // Método para formatar o CPF
        formatarCPF(cpf) {
            if (!cpf) return 'Não informado';
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },

    },

    mounted() {
      this.carregarDetalhes();
    },
  };

  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem; /* Espaço vertical entre o cabeçalho e o restante */
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left; /* Garante alinhamento à esquerda */
  }
  
  .form-content {
    margin-top: 1.5rem; /* Espaço adicional entre o cabeçalho e o conteúdo */
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  